import React from "react";
import { useTranslation } from 'next-i18next';
import { PrivacyWrapper } from './style';
import { ICommonModuleProps } from "../../Types";
import { useIsMobile } from "@/Hooks/useIsMobile";
import { getProfileModuleName } from "../../Helpers/getProfileModuleName";
import { ProfilePageModules } from "../..";
import MobileHeader from "@/Components/atoms/MobileHeader";


interface Props extends ICommonModuleProps {};

const Privacy = ({handleBackToMenu}: Props) => {
  const { t } = useTranslation(['terms']);

  const isMobile = useIsMobile();
  const backToMenu = () => {
    handleBackToMenu();
  };

  let title = getProfileModuleName(ProfilePageModules.service);

  return (
    <>
    {isMobile && <MobileHeader onBack={backToMenu} title={t(title)} />}
    <PrivacyWrapper>
      <div>
        <div dangerouslySetInnerHTML={{__html: t("terms:html_content") as string,}} />
      </div>
    </PrivacyWrapper>
    </>
  );
};

export default Privacy;
